import type { MergeBatchPayload, MergePayload } from "./request-typings";

/*                                                                        */
const BEACON_BYTE_LIMIT = 60_000;

/*                                                                     */
export function computeJsonBytes(value: unknown): number {
  return new TextEncoder().encode(JSON.stringify(value)).byteLength;
}

/*                                                                        */
export function isWithinBeaconLimit(byteSize: number): boolean {
  return byteSize <= BEACON_BYTE_LIMIT;
}

/**
 *
 *
 *
 *
 *
 *
 */
function chunkBySize<T>(
  items: T[],
  baseBytes: number,
  firstChunkBaseBytes: number = baseBytes,
): T[][] {
  const chunks: T[][] = [];
  let current: T[] = [];
  let currentBytes = firstChunkBaseBytes;

  for (const item of items) {
    const itemBytes = computeJsonBytes(item) + (current.length > 0 ? 1 : 0);
    if (currentBytes + itemBytes > BEACON_BYTE_LIMIT && current.length > 0) {
      chunks.push(current);
      current = [];
      currentBytes = baseBytes;
    }
    current.push(item);
    currentBytes += itemBytes;
  }
  if (current.length > 0) {
    chunks.push(current);
  }
  return chunks;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function splitMergePayload(payload: MergePayload): MergePayload[] {
  if (isWithinBeaconLimit(computeJsonBytes(payload))) {
    return [payload];
  }

  const features = payload.features ?? [];
  const skeleton: MergePayload = { ...payload, mergeValues: [], features: [] };
  const skeletonBytes = computeJsonBytes(skeleton);
  const mergeValuesBytes = computeJsonBytes(payload.mergeValues);
  /*                                                                         */
  const baseWithMergeValues = skeletonBytes + mergeValuesBytes - 2;

  if (isWithinBeaconLimit(baseWithMergeValues)) {
    const featureChunks = chunkBySize(features, skeletonBytes, baseWithMergeValues);
    if (featureChunks.length === 0) {
      return [payload];
    }
    return featureChunks.map((chunk, i) => ({
      ...skeleton,
      mergeValues: i === 0 ? payload.mergeValues : [],
      features: chunk,
    }));
  }

  /*                                                              */
  const mergeValueChunks = chunkBySize(payload.mergeValues, skeletonBytes);
  const featureChunks = chunkBySize(features, skeletonBytes);

  const results: MergePayload[] = mergeValueChunks.map((mv) => ({
    ...skeleton,
    mergeValues: mv,
    features: [],
  }));

  for (const fc of featureChunks) {
    results.push({ ...skeleton, mergeValues: [], features: fc });
  }

  return results;
}

/**
 *
 */
export function splitMergeBatchPayload(payload: MergeBatchPayload): MergeBatchPayload[] {
  if (isWithinBeaconLimit(computeJsonBytes(payload))) {
    return [payload];
  }

  const base: MergeBatchPayload = { ...payload, merges: [] };
  const baseBytes = computeJsonBytes(base);
  const mergeChunks = chunkBySize(payload.merges, baseBytes);

  return mergeChunks.map((chunk) => ({ ...base, merges: chunk }));
}
